import { render, staticRenderFns } from "./CategoriasProdutos.vue?vue&type=template&id=40dc9145&scoped=true"
import script from "./CategoriasProdutos.vue?vue&type=script&lang=js"
export * from "./CategoriasProdutos.vue?vue&type=script&lang=js"
import style0 from "./CategoriasProdutos.vue?vue&type=style&index=0&id=40dc9145&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dc9145",
  null
  
)

export default component.exports